/* ═══════════════════════════════════════════════
   TANARAS Extensions Landing Page — JS
   3-step flow: Länge → Haartyp → SET/JUST → PDP
   ═══════════════════════════════════════════════ */

(function() {
  'use strict';

  /* ─── STATE ─── */
  const state = { len: null, ht: null, sj: null };

  /* ─── PRODUCT URLS (actual Shopify PDPs) ─── */
  const URLS = {
    invisis: {
      set: {
        35: '/products/invisis-35-cm-1',
        45: '/products/invisis-set-extensions-wie-beim-friseur-45-cm2',
        55: '/products/invisis-set-extensions-wie-beim-friseur-55-cm2'
      },
      just: {
        35: '/products/just-invisis?variant=48813129072963',
        45: '/products/just-invisis?variant=48813130023235',
        55: '/products/just-invisis?variant=48813258113347'
      }
    },
    thinvisis: {
      set: {
        35: '/products/thinvisis-set-extensions-wie-beim-friseur-35-cm',
        45: '/products/thinvisis-set-extensions-wie-beim-friseur-45-cm',
        55: '/products/thinvisis-set-extensions-wie-beim-friseur-55-cm'
      },
      just: {
        35: '/products/just-thinvisis?variant=53874020385091',
        45: '/products/just-thinvisis?variant=53874020417859',
        55: '/products/just-thinvisis?variant=53874020450627'
      }
    }
  };

  /* ─── PRICES (ab-Preise, Unicolor Gruppe 1, Verdichtung) ─── */
  const PRICES = {
    set:  { 35: 175, 45: 220, 55: 300 },
    just: { 35: 125, 45: 170, 55: 250 }
  };

  /* ─── LENGTH NAMES ─── */
  const LEN_NAMES = { 35: 'Dezenter Look', 45: 'Klassisch', 55: 'Statement' };

  /* ─── DOM HELPERS ─── */
  const $ = (sel) => document.querySelector(sel);
  const $$ = (sel) => document.querySelectorAll(sel);

  /* ═══════════════════════════════════
     STEP 1 — LENGTH
  ═══════════════════════════════════ */
  window.telpPickLen = function(len) {
    state.len = len;

    // Update selection state
    $$('.telp-len-c').forEach(c => c.classList.remove('sel'));
    $('#telp-l' + len).classList.add('sel');

    // Show step 2 — scroll so eyebrow is roughly centered
    setTimeout(() => {
      $('#telp-s2').style.display = 'block';
      const hint = $('#telp-hint');
      if (hint) hint.classList.add('hidden');
      const el = $('#telp-s2');
      const top = el.getBoundingClientRect().top + window.scrollY - (window.innerHeight * 0.15);
      window.scrollTo({ top: top, behavior: 'smooth' });
    }, 120);

    // Update downstream if already selected
    if (state.ht) updateStep3Prices();
    if (state.sj) updateResult();
  };

  /* ═══════════════════════════════════
     STEP 2 — HAIR TYPE
  ═══════════════════════════════════ */
  window.telpPickHt = function(type) {
    state.ht = type;

    $$('.telp-ht-c').forEach(c => c.classList.remove('sel'));
    $('#telp-ht-' + type).classList.add('sel');

    setTimeout(() => {
      $('#telp-s3').style.display = 'block';
      updateStep3Prices();
      const el = $('#telp-s3');
      const top = el.getBoundingClientRect().top + window.scrollY - (window.innerHeight * 0.15);
      window.scrollTo({ top: top, behavior: 'smooth' });
    }, 120);

    if (state.sj) updateResult();
  };

  /* ═══════════════════════════════════
     STEP 3 — SET / JUST
  ═══════════════════════════════════ */
  window.telpPickSj = function(type) {
    state.sj = type;

    $$('.telp-sj-c').forEach(c => c.classList.remove('sel'));
    $('#telp-sj-' + type).classList.add('sel');

    updateResult();

    setTimeout(() => {
      $('#telp-result').scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 150);
  };

  /* ─── Update SET/JUST prices based on selected length ─── */
  function updateStep3Prices() {
    if (!state.len) return;
    const setEl = $('#telp-sj-set-price');
    const justEl = $('#telp-sj-just-price');
    if (setEl) setEl.textContent = 'ab ' + PRICES.set[state.len] + ' €';
    if (justEl) justEl.textContent = 'ab ' + PRICES.just[state.len] + ' €';
  }

  /* ═══════════════════════════════════
     RESULT CARD
  ═══════════════════════════════════ */
  function updateResult() {
    if (!state.len || !state.ht || !state.sj) return;

    const isSet = state.sj === 'set';
    const isInv = state.ht === 'invisis';
    const prodName = isInv ? 'INVISIS' : 'THINVISIS';
    const typeName = isSet ? 'SET' : 'JUST';
    const price = isSet ? PRICES.set[state.len] : PRICES.just[state.len];

    // Update card content
    const displayName = isSet ? prodName + ' SET' : 'JUST ' + prodName;
    $('#telp-res-prod').textContent = displayName;
    $('#telp-res-sub').textContent = state.len + ' cm · ' + LEN_NAMES[state.len];
    $('#telp-res-price').textContent = price + ' €';

    // Pills
    const pills = [
      state.len + ' cm',
      isInv ? 'Normales Haar' : 'Feines Haar'
    ];
    if (isSet) pills.push('Inkl. Tools');
    pills.push('27 Farben');
    if (isSet) pills.push('Farbumtausch');

    $('#telp-res-pills').innerHTML = pills
      .map(p => '<div class="telp-res-pill">' + p + '</div>')
      .join('');

    // CTA URL → actual Shopify PDP
    const url = URLS[state.ht][state.sj][state.len];
    $('#telp-res-cta').onclick = function() {
      window.location.href = url;
    };

    // Show result + bottom content
    $('#telp-result').style.display = 'block';
    const bottom = $('#telp-bottom');
    if (bottom) bottom.classList.add('visible');
  }

  /* ═══════════════════════════════════
     FAQ TOGGLE
  ═══════════════════════════════════ */
  window.telpToggleFaq = function(el) {
    const wasOpen = el.classList.contains('open');
    $$('.telp-fi').forEach(i => i.classList.remove('open'));
    if (!wasOpen) el.classList.add('open');
  };

  /* ─── SCROLL TO STEP 1 ─── */
  window.telpScrollToStart = function() {
    const el = $('#telp-s1');
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - (window.innerHeight * 0.15);
      window.scrollTo({ top: top, behavior: 'smooth' });
    }
  };

})();